
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casinos/[id]",
      function () {
        return require("private-next-pages/casinos/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casinos/[id]"])
      });
    }
  